import React from 'react';
import "./Footer.css"
const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <div class="footer">&copy; Copyright <span className="span-color">{year} </span>All right reserved by <span className="span-color">MD IMRANUL HAQUE</span></div>
    );
};

export default Footer;